import { createContext, useContext, useEffect, useState } from 'react';
import { getAllTableData } from '../services/benefitAmounts';
import { DateFormats, formatDate } from '../utils/utils';
import { AuthStore } from './auth';

const date = new Date();

export type TransactionHistoryState = {
    benefitAmounts: [];
};

export const TransactionHistoryStore = createContext<TransactionHistoryState>({
    benefitAmounts: [],
});

const { Provider } = TransactionHistoryStore;

export const TransactionHistoryProvider = ({ children }: any) => {
  const [, , , selectedPersona] = useContext(AuthStore) || [];
  const [transactionHistoryState, setTransactionHistoryState] =
    useState<TransactionHistoryState>({
        benefitAmounts: [],
    });

  useEffect(() => {
    let count = 0;
    let benefitAmounts = getAllTableData(selectedPersona).map((x: any) => {
      count += 5;

      return {
        ...x,
        submitted: formatDate(
          new Date(date.getFullYear(), date.getMonth(), date.getDate() - count),
          DateFormats.US
        ),
      };
    });

    setTransactionHistoryState({
        benefitAmounts,
    });
  }, [selectedPersona]);

  return <Provider value={transactionHistoryState}>{children}</Provider>;
};
